// extracted by mini-css-extract-plugin
export default {"konyv":"Konyv_konyv__hQ09g","konyvdesign":"Konyv_konyvdesign__4Ya+b"};